export default "__VITE_ASSET__CKzjFGiG__"